import { BehaviorSubject } from 'rxjs';

import Case from '../models/Case';

export default class ViewerBloc {
  resourceInfo$ = new BehaviorSubject(null);
  error$ = new BehaviorSubject(false);
  childResources$ = new BehaviorSubject([]);

  constructor({ appRepository, resourceRepository, casesRepository, patientRepository }) {
    this.appRepository = appRepository;
    this.resourceRepository = resourceRepository;
    this.casesRepository = casesRepository;
    this.patientRepository = patientRepository;
  }

  async getResourceInfo(uuid, caseId, token, hideContext = true) {
    try {
      this.appRepository.handleOpenLoading();
      let resourceUuid = uuid;

      if (caseId) {
        const caseStudy = await this.casesRepository.getCase(caseId, token);
        const currentCase = new Case(caseStudy);

        resourceUuid = currentCase?.dicomStudy?.uuid;
      }

      const resourceInfo = await this.resourceRepository.getResourceInfo(resourceUuid, token, hideContext);
      this.resourceInfo$.next(resourceInfo);

      let childResources = [];
      if (resourceInfo?.id) {
        childResources = await this.patientRepository.getChildResourcesLink(resourceInfo.id, token);
      }

      this.childResources$.next(childResources);
    } catch (error) {
      this.error$.next(true);
    } finally {
      this.appRepository.handleCloseLoading();
    }
  }
}
